import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  ourCompanies: {
    id: 'components.Layout.OurCompanies',
    defaultMessage: 'Nasze spółki'
  },
  missionAndVision: {
    id: 'components.Layout.missionAndVision',
    defaultMessage: 'Misja i wizja'
  },
  teamOfExperts: {
    id: 'components.Layout.TeamOfExperts',
    defaultMessage: 'Zespół ekspertów'
  },
  caseStudies: {
    id: 'components.Layout.CaseStudies',
    defaultMessage: 'Case studies'
  },
  pressRoom: {
    id: 'components.Layout.PressRoom',
    defaultMessage: 'Press room'
  },
  jobOffers: {
    id: 'components.Layout.JobOffers',
    defaultMessage: 'Oferty pracy'
  },
  contact: {
    id: 'components.Layout.Contact',
    defaultMessage: 'Kontakt'
  },
  whistleblowing: {
    id: 'components.Layout.Whistleblowing',
    defaultMessage: 'Zgłaszanie nieprawidłowości'
  },
  history: {
    id: 'components.Layout.History',
    defaultMessage: 'Historia'
  },
  strategy: {
    id: 'components.Layout.Strategy',
    defaultMessage: 'Strategia'
  },
  synergy: {
    id: 'components.Layout.Synergy',
    defaultMessage: 'Synergia'
  },
  authorities: {
    id: 'components.Layout.Authorities',
    defaultMessage: 'Władze'
  },
  CSR: {
    id: 'components.Layout.CSR',
    defaultMessage: 'CSR'
  },
  news: {
    id: 'components.Layout.news',
    defaultMessage: 'Aktualności'
  },
  mediaAboutUs: {
    id: 'components.Layout.MediaAboutUs',
    defaultMessage: 'Media o nas'
  },
  results: {
    id: 'components.Layout.Results',
    defaultMessage: 'Wyniki'
  },
  reports: {
    id: 'components.Layout.Reports',
    defaultMessage: 'Raporty'
  },
  unionProjects: {
    id: 'components.Layout.UnionProjects',
    defaultMessage: 'Projekty Unijne'
  },
  corporateGovernance: {
    id: 'components.Layout.CorporateGovernance',
    defaultMessage: 'Ład korporacyjny'
  },
  termsOfUse: {
    id: 'components.Layout.TermsOfUse',
    defaultMessage: 'Regulamin'
  },
  forInvestors: {
    id: 'components.Layout.ForInvestors',
    defaultMessage: 'Relacje inwestorskie'
  },
  currentReports: {
    id: 'components.Layout.CurrentReports',
    defaultMessage: 'Raporty bieżące'
  },
  infoAboutCompany: {
    id: 'components.Layout.InfoAboutCompany',
    defaultMessage: 'Rynek i działalność spółki'
  },
  rodoPolicy: {
    id: 'components.Layout.RodoPolicy',
    defaultMessage: 'Ochrona Danych Osobowych w grupie kapitałowej TenderHut'
  },
  zszPolicy: {
    id: 'components.Layout.ZszPolicy',
    defaultMessage: 'ISO 27001 i 9001 w TenderHut'
  }
});



// WEBPACK FOOTER //
// ./src/common/messages/Layout.intl.js